@switch (mode()) {
	@case ("RENAME") {
		@if (entry.icon) {
			<i class="ico" [ngClass]="entry.icon"></i>
		}
		<ng-content />
	}
	@case ("ADD") {
		@if (entry.icon) {
			<i class="ico" [ngClass]="entry.icon"></i>
		}
		<ng-content />
	}
	@default {
		@if (entry.icon) {
			<i class="ico" [ngClass]="entry.icon"></i>
		}
		<div class="text">
			@if (entry.label) {
				<span class="h3" [ngClass]="entry.labelClasses">{{ entry.label }}</span>
			}
			@if (entry.labelTranslate) {
				<span class="h3" [translate]="entry.labelTranslate"></span>
			}
		</div>
		<ng-container />
	}
}
